import { UserNotificationActionEnum } from '../enums/UserNotificationActionEnum';
import { IUserNotificationState } from '../interfaces/IUserNotificationState';
import { UserNotificationAction } from '../types/UserNotificationAction';
import { notificationReadStatusOptions, UNREAD_SELECT_OPTION } from '../constants/NotificationReadStatusOptions';
import { INotificationRecord } from '../../../APIPackage/UserNotificationModule/interfaces/NotificationRecord';

const initial: IUserNotificationState = {
  data: [],
  totalCount: 0,
  searchTypeSelectOption: notificationReadStatusOptions[0],
  unReadNotificationCount: 0,
  searchText: '',
  page: 0,
};

export function userNotificationReducer(state = initial, action: UserNotificationAction) {
  switch (action.type) {
    case UserNotificationActionEnum.USER_NOTIFICATIONS_SET_SELECT_OPTION: {
      const newState: IUserNotificationState = {
        ...state,
        searchTypeSelectOption: action.payload.data,
      };

      return newState;
    }
    case UserNotificationActionEnum.USER_NOTIFICATIONS_SET_PAGE: {
      const newState: IUserNotificationState = {
        ...state,
        page: action.payload.page,
      };

      return newState;
    }
    case UserNotificationActionEnum.USER_NOTIFICATIONS_SET_SEARCH_TEXT: {
      const newState: IUserNotificationState = {
        ...state,
        searchText: action.payload.text,
      };

      return newState;
    }
    case UserNotificationActionEnum.USER_NOTIFICATIONS_SET_DATA: {
      const records = action.payload.data.list.map(item => {
        const record: INotificationRecord = {
          ...item,
          isUnread: item.userNotificationRecipients[0].isUnread,
          userNotificationId: item.userNotificationRecipients[0].id,
        };

        return record;
      });

      const newState: IUserNotificationState = {
        ...state,
        data: records,
        totalCount: action.payload.data.totalCount,
      };

      return newState;
    }
    case UserNotificationActionEnum.USER_NOTIFICATIONS_SET_UNREAD_COUNT: {
      const newState: IUserNotificationState = {
        ...state,
        unReadNotificationCount: action.payload.data.totalCount,
      };

      return newState;
    }
    case UserNotificationActionEnum.USER_NOTIFICATIONS_RESET_INITIAL_FORM_VALUES: {
      const newState: IUserNotificationState = {
        ...state,
        searchTypeSelectOption: UNREAD_SELECT_OPTION,
        searchText: '',
      };

      return newState;
    }

    case UserNotificationActionEnum.USER_NOTIFICATIONS_SET_FETCH_SETTING_BY_CODE: {
      const newState: IUserNotificationState = {
        ...state,
        settings: action.payload.settings,
      };

      return newState;
    }

    default:
      return state;
  }
}
